require("!!/var/www/html/pingovo_admin_angular/node_modules/script-loader/addScript.js")(require("!!/var/www/html/pingovo_admin_angular/node_modules/raw-loader/index.js!/var/www/html/pingovo_admin_angular/node_modules/bootstrap/dist/js/bootstrap.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/dist/js/bootstrap.min.js
// module id = 131
// module chunks = 14